import React from 'react';
import { Card, Badge } from 'react-bootstrap';

const PlatformStatus = ({ stats }) => {
    return (
        <Card>
            <Card.Header className="bg-secondary text-white">
                <h5 className="mb-0">
                    <i className="bi bi-people me-2"></i>
                    Platform Status
                </h5>
            </Card.Header>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Logged in Platform users (last 1hr)</span>
                    <Badge bg="success">
                        {stats.platform_users_last_1hr || '0'}
                    </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Logged in Platform users (last 24hrs)</span>
                    <Badge bg="success">
                        {stats.platform_users_last_24hrs || '0'}
                    </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span>Total Active Platform Users</span>
                    <Badge bg="success">
                        {stats.total_active_platform_users || '0'}
                    </Badge>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PlatformStatus;
